import wx from "weixin-js-sdk";
import { getData, getTxt } from "@/api/index"; // 根据实际路径修改

export function getShareInfo() {
  const url = "https://share.ruizhihuitech.com/h/";
  getData(url).then((res) => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
      appId: res.data.data.appId, // 必填，公众号的唯一标识
      timestamp: parseInt(res.data.data.timestamp), // 必填，生成签名的时间戳
      nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.data.signature, // 必填，签名
      jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的 JS 接口列表
    });

    wx.ready(() => {
      // 分享给朋友，朋友圈（即将废弃）
      wx.onMenuShareAppMessage({
        title: "智慧助老仿真学习系统",
        desc: "用好智能手机，轻松跨越数字鸿沟！",
        link: "https://share.ruizhihuitech.com/h/",
        imgUrl: "https://wechat.ruizhihuitech.com/image/%E5%B0%8F%E9%B9%BF%E6%A0%B7%E6%9C%BA.png",
      });

      wx.onMenuShareTimeline({
        title: "智慧助老仿真学习系统",
        desc: "用好智能手机，轻松跨越数字鸿沟！",
        link: "https://share.ruizhihuitech.com/h/",
        imgUrl: "https://wechat.ruizhihuitech.com/image/%E5%B0%8F%E9%B9%BF%E6%A0%B7%E6%9C%BA.png",
      });
      // // 分享给朋友，朋友圈
      // wx.updateAppMessageShareData({
      //   title: "智慧助老仿真学习系统",
      //   desc: "用好智能手机，轻松跨越数字鸿沟！",
      //   link: "https://share.ruizhihuitech.com",
      //   imgUrl: "https://wechat.ruizhihuitech.com/image/%E5%B0%8F%E9%B9%BF%E6%A0%B7%E6%9C%BA.png",
      // });

      // wx.updateTimelineShareData({
      //   title: "智慧助老仿真学习系统",
      //   desc: "用好智能手机，轻松跨越数字鸿沟！",
      //   link: "https://share.ruizhihuitech.com",
      //   imgUrl: "https://wechat.ruizhihuitech.com/image/%E5%B0%8F%E9%B9%BF%E6%A0%B7%E6%9C%BA.png",
      // });
    });

    wx.error((res) => {
      console.log("微信分享错误信息", res);
    });
  });
}
export async function getTxtData() {
  try {
    const res = await getTxt();
    console.log(res, "getTxt");
    return res;
  } catch (error) {
    console.error("Error in getTxt:", error);
    throw error;
  }
}
